import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const Container = styled.div<{ isSelected: boolean }>`
  position: relative;
  margin: ${theme.spacing.small} 0;
  border-radius: ${theme.borderRadius.medium};

  & *::selection {
    background-color: ${theme.color.designSystem.purple30};
  }

  border: ${({ isSelected }) =>
    isSelected
      ? `1px solid ${theme.color.designSystem.blackOpacity87}`
      : '1px solid transparent'};
`;

export const DisplayArea = styled.div`
  position: relative;
  border-radius: ${theme.borderRadius.medium} ${theme.borderRadius.medium} 0 0;
  background-color: ${theme.color.lightBeige};
  user-select: none;
`;

export const Display = styled.div<{ hasError: boolean }>`
  display: ${({ hasError }) => (hasError ? 'none' : 'flex')};
  min-height: ${theme.spacing.xxxGiant};
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0 ${theme.spacing.medium};
  overflow: auto;
`;

export const Error = styled.div<{ hasError: boolean }>`
  display: ${({ hasError }) => (hasError ? 'flex' : 'none')};
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: ${theme.spacing.medium};
  color: ${theme.color.designSystem.blackOpacity60};
  line-height: ${theme.font.lineHeight.copy};

  & > svg {
    padding-right: ${theme.spacing.xSmall};
  }
`;

export const SyntaxArea = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${theme.spacing.medium};
  line-height: ${theme.font.lineHeight.large};
  border-radius: 0 0 ${theme.borderRadius.medium} ${theme.borderRadius.medium};
  background-color: ${theme.color.darkBeige};

  &[hidden] {
    display: none;
  }
`;

export const LatexSyntax = styled.div`
  flex-grow: 1;
  font-size: ${theme.font.size.copy};
  font-family: 'Roboto Mono', monospace;
`;

export const EditorToggle = styled.span`
  position: absolute;
  right: ${theme.spacing.small};
  bottom: ${theme.spacing.small};
`;
